const BETA_STORAGE_KEY = 'beta';

export const persistBetaEnabled = (enabled: boolean) => {
    localStorage.setItem(BETA_STORAGE_KEY, enabled.toString());
};

export const isBetaEnabled = () => {
    return localStorage.getItem(BETA_STORAGE_KEY) === 'true';
};
